import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import es from "../locales/es.json";
import en from "../locales/en.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      es: { translation: es },
      en: { translation: en },
    },
    fallbackLng: "es",
    lng: localStorage.getItem("casarent_lang") || "es",
    interpolation: { escapeValue: false, defaultVariables: { app: localStorage.getItem("casarent_app_name") || "CasaRent" } },
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "casarent_lang",
      caches: ["localStorage"],
    },
  });

export default i18n;
